var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "px-5 pt-16 status-page api-docs-page",
      attrs: { justify: "center" },
    },
    [
      _c(
        "v-col",
        { attrs: { xl: "8", lg: "8", md: "10", sm: "12", cols: "12" } },
        [
          _c(
            "a",
            { staticClass: "back-link", attrs: { href: "/" } },
            [
              _c("v-icon", { staticClass: "mr-1", attrs: { small: "" } }, [
                _vm._v("mdi-arrow-left"),
              ]),
              _vm._v(" Back to SmartTMS "),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-6 mt-4 elevation-2 main-card" },
            [
              _c("label", { staticClass: "api-name" }, [
                _vm._v("SmartTrack API"),
              ]),
              _c("p", { staticClass: "mt-4" }, [
                _vm._v(
                  " This API endpoint allows you to track shipments and optionally make them available in the SmartTrack website. "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  " You can use this API to get the current status of a shipment and its tracking information. "
                ),
              ]),
              _c(
                "v-card",
                { staticClass: "endpoint-card my-4 pa-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "endpoint-row" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("span", { staticClass: "endpoint-label" }, [
                          _vm._v("API Endpoint:"),
                        ]),
                        _c("span", { staticClass: "http-method" }, [
                          _vm._v("POST"),
                        ]),
                        _c("code", { staticClass: "endpoint-path" }, [
                          _vm._v("/api/shipments/external/tracking"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("Environments"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "environment-card pa-4 elevation-1" },
                        [
                          _c("div", { staticClass: "environment-title" }, [
                            _vm._v("TEST"),
                          ]),
                          _c("div", { staticClass: "environment-url" }, [
                            _c("code", [
                              _vm._v(
                                "https://tms.uat.afs.net/api/shipments/external/tracking"
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "environment-card pa-4 elevation-1" },
                        [
                          _c("div", { staticClass: "environment-title" }, [
                            _vm._v("PRODUCTION"),
                          ]),
                          _c("div", { staticClass: "environment-url" }, [
                            _c("code", [
                              _vm._v(
                                "https://tms.afs.net/api/shipments/external/tracking"
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("label", { staticClass: "sub-section" }, [
                _vm._v("HTTP Headers"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-card",
                { staticClass: "header-card pa-4 mb-4" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("code", { staticClass: "header-code" }, [
                          _vm._v("Content-Type: application/json"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("label", { staticClass: "sub-section" }, [
                _vm._v("Request Fields"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                { staticClass: "table-header mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("Field")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("Type")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("Required")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "length-col", attrs: { cols: "2" } },
                    [_vm._v("Length")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "4" } },
                    [_vm._v("Description")]
                  ),
                ],
                1
              ),
              _vm._l(_vm.requestFields, function (field) {
                return _c(
                  "v-row",
                  { key: field.name, staticClass: "table-row mx-1" },
                  [
                    _c(
                      "v-col",
                      { staticClass: "field-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.name))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "type-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.type))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "require-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.required ? "yes" : "no"))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "length-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.length))]
                    ),
                    _c("v-col", {
                      staticClass: "description-col",
                      attrs: { cols: "4" },
                      domProps: { innerHTML: _vm._s(field.description) },
                    }),
                  ],
                  1
                )
              }),
              _c("label", { staticClass: "sub-section" }, [
                _vm._v("Request Example"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("pre", [
                      _c("code", [
                        _vm._v(
                          'POST /api/shipments/external/tracking HTTP/1.1\nHost: tms.uat.afs.net\nContent-Type: application/json\nContent-Length: 249\n\n{\n    "pro": "1234567890",\n    "scac": "ABCD",\n    "origZip": "12345",\n    "destZip": "67890",\n    "accountId": "AM00012345",\n    "makeAvailableInSmartTrack": true\n}'
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("label", { staticClass: "sub-section" }, [
                _vm._v("Response Fields"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                { staticClass: "table-header mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("Field")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("Type")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("Required")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "length-col", attrs: { cols: "2" } },
                    [_vm._v("Length")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "4" } },
                    [_vm._v("Description")]
                  ),
                ],
                1
              ),
              _vm._l(_vm.responseFields, function (field) {
                return _c(
                  "v-row",
                  { key: field.name, staticClass: "table-row mx-1" },
                  [
                    _c(
                      "v-col",
                      { staticClass: "field-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.name))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "type-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.type))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "require-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.required ? "yes" : "no"))]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "length-col", attrs: { cols: "2" } },
                      [_vm._v(_vm._s(field.length))]
                    ),
                    _c("v-col", {
                      staticClass: "description-col",
                      attrs: { cols: "4" },
                      domProps: { innerHTML: _vm._s(field.description) },
                    }),
                  ],
                  1
                )
              }),
              _c("label", { staticClass: "sub-section" }, [
                _vm._v("Response Example"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("pre", [
                      _c("code", [
                        _vm._v(
                          '{\n    "notifications": [\n        "Freight Charges are shown on shipments for which the logged in user is the payor of the freight charges.",\n        "Reported delivery time is subject to change based upon verification.",\n        "Freight Charges are subject to change upon audit.",\n        "Appointment: Customer requested appointment; 01/15/2025 11:00"\n    ],\n    "statusUpdates": [\n        {\n            "location": {\n                "name": "",\n                "additionalName": "",\n                "addressline1": "",\n                "addressline2": "",\n                "city": "",\n                "state": "",\n                "postal": "",\n                "country": "",\n                "phone": "",\n                "fax": "",\n                "contactName": "",\n                "contactPhone": "",\n                "contactExtention": "",\n                "contactEmail": "",\n                "addressType": 2\n            },\n            "carrierSCAC": "ABCD",\n            "assignedNumber": null,\n            "dateTimeStamp": "01/15/2025 11:50",\n            "shipmentStatus": 3,\n            "description": "Delivered",\n            "weightQualifier": null,\n            "weight": null,\n            "weightUnits": 0,\n            "ladingQuantity": null,\n            "equipmentNumber": null,\n            "equipmentDescriptionCode": null\n        }\n    ],\n    "shipper": {\n        "name": "ACME COMPANY",\n        "additionalName": "",\n        "addressline1": "123 MAIN STREET",\n        "addressline2": null,\n        "city": "ANYTOWN",\n        "state": "CA",\n        "postal": "12345",\n        "country": null,\n        "phone": "",\n        "fax": "",\n        "contactName": "",\n        "contactPhone": "",\n        "contactExtention": "",\n        "contactEmail": "",\n        "addressType": 0\n    },\n    "consignee": {\n        "name": "XYZ CORPORATION",\n        "additionalName": "",\n        "addressline1": "456 OAK AVENUE",\n        "addressline2": null,\n        "city": "SOMEWHERE",\n        "state": "AZ",\n        "postal": "67890",\n        "country": null,\n        "phone": "",\n        "fax": "",\n        "contactName": "",\n        "contactPhone": "",\n        "contactExtention": "",\n        "contactEmail": "",\n        "addressType": 2\n    },\n    "ladingExceptions": [],\n    "carrierSCAC": "ABCD",\n    "proNumber": "123-4567890",\n    "poNumber": "PO12345",\n    "bolNumber": "BOL98765",\n    "shipperId": null,\n    "reference": {\n        "referenceType": 18,\n        "referenceValue": "1234567890"\n    },\n    "customerRefNumber": "RequestId: test2025-01-15.1234",\n    "shipmentType": null,\n    "pickupDate": "01/10/2025",\n    "pickupTime": "08:00",\n    "deliveryDate": "01/15/2025",\n    "deliveryTime": "11:50"\n}'
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }